import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';

import DatePicker, { registerLocale } from 'react-datepicker';
import ru from 'date-fns/locale/ru';

registerLocale('ru', ru);

import formatPhone from '~h/format-phone';

class Input extends Component {
  static propTypes = {
    accent: PropTypes.bool,
    center: PropTypes.bool,
    disabled: PropTypes.bool,
    error: PropTypes.bool,
    name: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    phone: PropTypes.bool,
    kladr: PropTypes.bool,
    inn: PropTypes.bool,
    kpp: PropTypes.bool,
    bik: PropTypes.bool,
    paymentAccount: PropTypes.bool,
    passportSeries: PropTypes.bool,
    passportNumber: PropTypes.bool,
    passport: PropTypes.bool,
    date: PropTypes.bool,
    'data-valid': PropTypes.bool,
    placeholder: PropTypes.string,
    children: PropTypes.node,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  };

  static defaultProps = {
    accent: false,
    center: false,
    disabled: false,
    error: false,
    phone: false,
    kladr: false,
    inn: false,
    kpp: false,
    bik: false,
    paymentAccount: false,
    passportSeries: false,
    passportNumber: false,
    passport: false,
    date: false,
    'data-valid': true,
    placeholder: '',
    value: '',
    name: '',
    children: null,
    onFocus: () => {},
    onChange: () => {},
    onBlur: () => {},
  };

  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
    };

    this.datePickerRef = React.createRef();
  }

  getMask = () => {
    if (this.props.phone) {
      return '+7 (999) 999-99-99';
    }

    if (this.props.kladr) {
      return '9999999999999';
    }

    if (this.props.inn) {
      return '9999999999';
    }

    if (this.props.kpp) {
      return '999999999';
    }

    if (this.props.bik) {
      return '999999999';
    }

    if (this.props.paymentAccount) {
      return '99999999999999999999';
    }

    if (this.props.passportSeries) {
      return '9999';
    }

    if (this.props.passportNumber) {
      return '999999';
    }

    if (this.props.passport) {
      return '9999 999999';
    }

    if (this.props.date) {
      return '99.99.9999';
    }

    return '*';
  };

  static getDerivedStateFromProps(props) {
    return {
      value: props.value,
    };
  }

  getInput() {
    const {
      disabled,
      name,
      phone,
      date,
      placeholder,
      onFocus,
      onBlur,
    } = this.props;
    const { value } = this.state;

    // if (disabled) {
    //   let val = value;

    //   if (phone) val = formatPhone(val);

    //   return <p className="inp__field">{`${val}\u00A0`}</p>;
    // }

    const phoneClassStr = `inp__field ${
      !this.props['data-valid'] ? 'inp__field--error' : ''
    }`;

    switch (true) {
      case date:
        return (
          <React.Fragment>
            <div className="inp__datePlaceholder">
              <DatePicker
                // selected={value}
                dateFormat="dd.MM.yyyy"
                locale="ru"
                ref={this.datePickerRef}
                customInput={<div style={{ display: 'none' }}></div>}
                onChange={dateValue => {
                  const parsedDate = dateValue.toLocaleDateString('ru');
                  const eventMimic = { target: { value: parsedDate } };
                  this.onChange(eventMimic);

                  setTimeout(() => {
                    // eslint-disable-next-line
                    this.datePickerRef.current?.setOpen(false);
                  }, 0);
                }}
              />
            </div>
            <InputMask
              disabled={disabled}
              className={phoneClassStr}
              placeholder={placeholder}
              name={name}
              mask={this.getMask()}
              onChange={this.onChange}
              type="text"
              onFocus={onFocus}
              onBlur={onBlur}
              data-valid={this.props['data-valid']}
              value={value}
              onClick={() => {
                // eslint-disable-next-line
                this.datePickerRef.current?.setOpen(true);
              }}
            ></InputMask>
          </React.Fragment>
        );
      default:
        return (
          <InputMask
            disabled={disabled}
            className={phoneClassStr}
            placeholder={placeholder}
            name={name}
            mask={this.getMask()}
            onChange={this.onChange}
            type="text"
            onFocus={onFocus}
            onBlur={onBlur}
            data-valid={this.props['data-valid']}
            value={value}
          />
        );
    }
  }

  onChange = e => {
    const { onChange, name } = this.props;

    this.setState({
      value: e.target.value,
    });

    if (onChange) onChange(e.target.value, name);
  };

  render() {
    const { accent, center, error, date } = this.props;
    const classes = ['inp'];

    if (accent) classes.push('inp--accent');
    if (center) classes.push('inp--center');
    if (error) classes.push('inp--error');
    if (date) classes.push('inp--overlay');

    return (
      /* eslint-disable */
      <label className={classes.join(' ')}>
        {this.getInput()}
        {this.props.children}
      </label>
      /* eslint-enable */
    );
  }
}

export default Input;
